import Cookies from 'js-cookie';

const language = Cookies.get('language') || 'en_US';

let TIMEZONE_OFFSET_LIST = [];

export const getTimeZones = () => {
  return import(`../../../__assets__/timezones/`)
    .then((module) => {
      const list = module[language].map((item) => {
        const [zoneId, gmt, [name]] = item;
        const temp = {
          zoneId: zoneId,
          offset: gmt.slice(1, -1),
          gmt,
          name,
        };
        return temp;
      });
      TIMEZONE_OFFSET_LIST = list;
    })
    .catch(() => {
      // empty
    });
};

const prototype = {
  constructor: create,
  init: function (ms) {
    this._date = ms ? new Date(ms) : new Date();
  },
  tz: function (timezone) {
    let ms = this.getTimeZoneTime(this.time(), timezone);
    this._date = new Date(ms);
    this._tz = this.getGMTOffset(timezone);
    return this;
  },
  year: function () {
    return this._date.getFullYear();
  },
  month: function () {
    return this._date.getMonth() + 1;
  },
  date: function () {
    return this._date.getDate();
  },
  hour: function () {
    return this._date.getHours();
  },
  minute: function () {
    return this._date.getMinutes();
  },
  time: function () {
    return this._date.getTime();
  },
  /**
   * Get GMT offset string by given timezone, .eg GMT+00:00.
   * @param timezone {String} - timezone string.
   */
  getGMTOffset: function (timezone) {
    let tzObj = TIMEZONE_OFFSET_LIST.find(function (item) {
      return item.zoneId == timezone;
    });

    return tzObj ? tzObj.offset : undefined;
  },
  getOffset: function (timeZoneStr) {
    let offsetStr = this.getGMTOffset(timeZoneStr);

    if (offsetStr) {
      let offset = offsetStr.replace('GMT', '').split(':');
      let hour = parseInt(offset[0]) * 60,
        mins = parseInt(offset[1]);

      return hour >= 0 ? hour + mins : hour - mins;
    }

    return null;
  },
  getTimeZoneTime: function (srcTime, timeZoneStr) {
    let time = srcTime;
    if (timeZoneStr !== '') {
      // 获取本地时间offset, 分钟
      let localOffset = new Date(srcTime).getTimezoneOffset();
      // 获得目标时区offset，分钟
      let offset = this.getOffset(timeZoneStr);
      if (offset != null) {
        time = srcTime + 60000 * (localOffset + offset);
      }
      time = new Date(time).getTime();
    }
    return time;
  },
  getLocalTimeZoneOffset: function () {
    return new Date().getTimezoneOffset();
  },
  getGMTOffsetObj: function (timezone) {
    const found = TIMEZONE_OFFSET_LIST.find((item) => {
      return item.zoneId === timezone;
    });
    return found;
  },
};

function create(ms) {
  const instance = Object.create(prototype);
  instance.init(ms);
  return instance;
}

export default create;
